// dt-theme.js

// ----------------------------------------------
// Your existing theme JS
// ----------------------------------------------

$("swiper-component .testimonials-list").each(function(index, element){
    var $this = $(this);
    $this.addClass("instance-" + index);
    $this.find(".swiper-button-prev").addClass("btn-prev-" + index);
    $this.find(".swiper-button-next").addClass("btn-next-" + index);
    var swiper = new Swiper(".instance-" + index, {
        // your settings ...
        nextButton: ".btn-next-" + index,
        prevButton: ".btn-prev-" + index
    });
});

if($('#preloader').length > 0) {  
  $(window).on('load', function() {
    $("#preloader").delay(350).fadeOut("slow", function() {
      if($('.preloader-overflow').length > 0) {
        $('body').removeClass('preloader-overflow');   
      }
    });
  });
}

InitCustomFunctions();

function InitCustomFunctions() { 
  if ($('.pagination-method-loadmore_btn').length > 0) {
    var AjaxMethod = 'click';
  } else {
    var AjaxMethod = 'scroll';
  }

  if ($('.collection #AjaxinatePagination').length > 0) {
    var endlessScroll = new Ajaxinate({
      container: '.AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: AjaxMethod,
      offset: 0,
      callback: null
    });
  }

  if ($('.toggleFilter').length > 0) {  
    const filter = document.querySelector(".toggleFilter");
    const sidebar = document.querySelector(".facets-vertical");
    const closeDiv = document.querySelector(".close-sidebar");

    filter.addEventListener("click", () => {
      filter.classList.toggle("active");
      sidebar.classList.toggle("open");
    });

    closeDiv.addEventListener("click", () => {
      filter.classList.remove("active");
      sidebar.classList.remove("open");
    });
  }

  // product page color variant to select thumbnail img change color_variants
  $('input:radio[name="Color"]').click(function() {
    const cvariant = $(this).val();  
    $('input:radio[name="Color"]').next('.swatch-element').removeClass('clicked');
    $(this).next('.swatch-element').addClass('clicked');
    $('.slick-list').addClass('height_fix');
    $('.thumbnail-list__item').each(function() {
      const variant_val = $(this).find('img').attr("alt");
      if (cvariant == variant_val) {
        $(this).addClass('show').removeClass('hidden');
      } else {
        $(this).addClass('hidden').removeClass('show');
      }
    });
  });

  // Item swatch trigger
  $(document).on('click', '.color-values a', function() {
    $('.color-values a').removeClass('active');
    $(this).addClass('active');
  });

  $(document).on('click', '.size-values a', function() {
    const parent = $(this).parents('.card__content');
    $('.size-values a', parent).removeClass('active');
    $(this).addClass('active');
  });

  $('body').on('click', '.swatch span', function() {
    const imgData = $(this).data("image");
    if (imgData.indexOf("no-image") === -1) {
      $(this).closest('.card__content').find('.featured-image').attr('srcset', imgData);
    }
    const PickedColor = $(this).data("variant-item");
    if ($('.choosen-swatch').length > 0) {
      $(this).closest('.card__content').find('.full-unstyled-link span').text(' - ' + PickedColor);
    }
    if ($(this).closest('.swatch').hasClass('color')) {
      const variant = $(this).data('id');
      $(this).closest('.card__content').find('.variant-push').val(variant);
      // update size swatches...
      $(this).closest('.card__content').find('.variant-option-size .swatch').each(function() {
        let swatch_size_vars = $(this).find('span').data('variant-title').split('/');
        swatch_size_vars = swatch_size_vars.map(n => n.trim().toLowerCase().replace(/ /g,'-'));
        if (swatch_size_vars.indexOf(PickedColor.toLowerCase()) >= 0) {
          $(this).parent().toggleClass('active');
        }
      });
    }
    if ($(this).closest('.swatch').hasClass('size')) {
      const variant = $(this).data('id');
      $(this).closest('.card__content').find('.variant-push').val(variant);
    }
  });

  $('body').on('click', '.color-values-plus a', function(e) {
    e.preventDefault();
    $(this).closest('.variant-option-color').find('.show-on-click').css('display', 'flex');
    $(this).hide();
  });

  $(".custom-product-grid li").click(function(){
    const classNames = "grid--1-col-desktop grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop";
    const getCols = $(this).data('cols');
    $('.custom-product-grid li').removeClass('active');
    $(this).addClass("active");
    $('ul#product-grid').removeClass(classNames).addClass(getCols);  
  });

  if ($('.filter-buttons').length > 0) {
    const viewExists = document.querySelector('.grid-view-button');
    if (viewExists && viewExists.classList.contains('layout-mode')) {
      const listViewButton = document.querySelector('.list-view-button');
      const gridViewButton = document.querySelector('.grid-view-button');
      const list = document.querySelector('ul.view-mode');
      const gridviewlist = document.querySelector('.custom-product-grid');

      listViewButton.onclick = () => {
        listViewButton.classList.add('active');
        gridViewButton.classList.remove('active');
        list.classList.toggle('list-view-filter', true);
        gridviewlist.classList.add('hidden');
      };
      gridViewButton.onclick = () => {
        gridViewButton.classList.add('active');
        listViewButton.classList.remove('active');
        list.classList.toggle('list-view-filter', false);
        gridviewlist.classList.remove('hidden');
      };
    }
  }

  if ($('#swiper-sidebar-carousel').length > 0) {
    var swiper = new Swiper("#swiper-sidebar-carousel", {        
      navigation: {
        nextEl: "#swiper-sidebar-next",
        prevEl: "#swiper-sidebar-prev",
      },
    });
  }
}  // end InitCustomFunctions()

// ----------------------------------------------
// AJAX cart wiring (requires cart.js loaded first)
// ----------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  // 1) Quantity buttons (+ / –)
  // document.body.addEventListener('click', async (e) => {
  //   const btn = e.target.closest('.quantity__button');
  //   if (!btn) return;
  //   e.preventDefault();

  //   const wrapper = btn.closest('.cart-item');
  //   const input   = wrapper.querySelector('.quantity__input');
  //   let   qty     = parseInt(input.value, 10) + (btn.name === 'plus' ? 1 : -1);
  //   qty = Math.max(0, qty);
  //   input.value = qty;

  //   const line = input.dataset.index;
  //   wrapper.classList.add('is-loading');
  //   try {
  //     await window.changeQuantity(line, qty);
  //   } catch (err) {
  //     console.error('Quantity update failed', err);
  //   } finally {
  //     wrapper.classList.remove('is-loading');
  //   }
  // });

  // // 2) Direct input changes (debounced)
  // let inputTimer;
  // document.body.addEventListener('input', (e) => {
  //   if (!e.target.matches('.quantity__input')) return;
  //   clearTimeout(inputTimer);
  //   inputTimer = setTimeout(async () => {
  //     const input = e.target;
  //     let qty     = parseInt(input.value, 10) || 0;
  //     input.value = qty;
  //     const line  = input.dataset.index;
  //     input.closest('.cart-item').classList.add('is-loading');
  //     try {
  //       await window.changeQuantity(line, qty);
  //     } catch (err) {
  //       console.error('Quantity update failed', err);
  //     } finally {
  //       input.closest('.cart-item').classList.remove('is-loading');
  //     }
  //   }, 300);
  // });

  // 3) Add-to-cart forms
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const drawer   = document.getElementById('cart-drawer');
      const formData = new FormData(form);
      try {
        await window.addToCart(formData);
        drawer?.classList.add('is-open');
      } catch (err) {
        console.error('Add to cart failed', err);
        alert('Could not add to cart. Please try again.');
      }
    });
  });
});
